var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3165",
    "data-name": "Group 3165",
    transform: "translate(-1.675 -1.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3166",
    "data-name": "Group 3166",
    transform: "translate(1.675 1.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M14.175,1.914a12.5,12.5,0,1,0,12.5,12.5A12.5,12.5,0,0,0,14.175,1.914Zm0,22.525a10.025,10.025,0,1,1,9.963-10.025A10.062,10.062,0,0,1,14.175,24.439Z",
    transform: "translate(-1.675 -1.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M40.878,32.446l-.124-.124a1.158,1.158,0,0,0-1.609,0l-2.785,2.785-2.785-2.785a1.158,1.158,0,0,0-1.609,0l-.124.124a1.158,1.158,0,0,0,0,1.609l2.785,2.785-2.785,2.785a1.158,1.158,0,0,0,0,1.609l.124.124a1.158,1.158,0,0,0,1.609,0l2.785-2.785,2.785,2.785a1.158,1.158,0,0,0,1.609,0l.124-.124a1.158,1.158,0,0,0,0-1.609L38.094,36.84l2.785-2.785A1.158,1.158,0,0,0,40.878,32.446Z",
    transform: "translate(-23.799 -24.216)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modalClose.99abea6200632fbd36f7243be8bcc4a5.svg";
export { ForwardRef as ReactComponent };